var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.text",
  title: "Control Preview: Text",
  description: "Read-only preview renderer for plain text-like control values.",
  fields: {
    "value": { title: "Value", type: "*", description: "Value to preview." },
    "emptyText": { title: "Empty Text", type: "string", description: "Fallback text for empty values.", default: "Not provided" }
  }
});

var helper = require("./helpers/control.preview.js");

exports.render = async function(options) {
  var text = helper.valueToText(options.value);
  if (!text) {
    text = options.emptyText || "Not provided";
    return helper.renderDoc({
      n: "span",
      c: "ua-control-preview-empty",
      i: text
    });
  }

  return helper.renderDoc({
    n: "span",
    c: "ua-control-preview-text",
    i: text
  });
};
